module.exports = __webpack_public_path__ + "img/coflow-logo.42681d74.svg";